<template>
  <v-container class="mx-1" fluid v-if="languageData.section && languageData.labels">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="e1" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header class="autoheight" style="justify-content: left !important;">
              <div class="py-5 pl-5">
                <BackButton />
              </div>
              <v-stepper-step :complete="e1 > 1" step="1">{{ languageData.section.first }}</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formS" v-model="validS" @hook:mounted="handleForm('formS')">
                        <p class="text-h5 mb-7">{{ languageData.section.first }}</p>
                        <v-row>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                            height="55px"
                            outlined
                            :placeholder="languageData.labels.firstName"
                            :label="languageData.labels.firstName"
                            name="firstname"
                            :rules="rules.firstname"
                            v-model="data.firstname"></v-text-field>
                          </v-col>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                            height="55px"
                            outlined
                            :placeholder="languageData.labels.lastName"
                            :label="languageData.labels.lastName"
                            name="lastname"
                            :rules="rules.lastname"
                            v-model="data.lastname"></v-text-field>
                          </v-col>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  height="55px"
                                  outlined
                                  v-model="data.birthdate"
                                  label="Birthday date"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="data.birthdate"
                                :active-picker.sync="activePicker"
                                :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                min="1950-01-01"
                                @change="save"
                            ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                            <v-text-field
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.phone"
                              :label="languageData.labels.phone"
                              name="phone"
                              v-model="data.phone"></v-text-field>
                          </v-col>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                            <v-text-field
                            height="55px"
                            outlined
                            :placeholder="languageData.labels.insuranceNumber"
                            :label="languageData.labels.insuranceNumber"
                            name="insuranceNumber"
                            v-model="data.insuranceNumber"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-card>
                <v-row justify="center" style="padding: 0 24px">
                  <v-col cols="12">
                    <div class="d-flex justify-end">
                      <v-btn
                        class="button-shadow mb-5"
                        color="primary"
                        style="padding-left: 25px !important; padding-right: 25px !important"
                        height="55px"
                        :loading="dataSaveIsFetching || updateIsFetching"
                        @click="saveEmployeData">{{ languageData.btnSubmit }}</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <ModalInfo :typeInfo="typeInfoEmployeeSave || typeInfoEmployeeUpdate" :headModal="headInfoEmployeeSave || headInfoEmployeeUpdate" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isEmployeeSave || isEmployeeUpdate" :text-modal="textInfoEmployeeSave || textInfoEmployeeUpdate"></ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";
import hexColorGenerator from "../../../../helpers/hexColorGenerator";
import BackButton from "../../../../components/Global/BackButton";

 export default {
   name: "EmployeesForm",
   props: {
    layout: String
   },
   components: {BackButton, ModalInfo},
   mounted() {
       if(this.layout === "edit") {
         this.getEmployee();
       }
      eventBus.$on("getEmployeeSuccess", () => {
        if(this.dataReceive !== null) {
         this.data = this.dataReceive;
        }
      });
      eventBus.$on("saveEmployeeFailure", (errorsData) => {
       this.rules = handleFormError(errorsData);
       this.$refs.formS.validate();
      });
   },
   data() {
     return {
       data: {},
       e1: 1,
       rules: {},
       validS: false,
       menu: false,
       activePicker: null,
     }
   },
   methods: {
     ...mapActions("saveEmployee", ["storeEmployee", "updateVisibleModal"]),
     ...mapActions("getEmployee", ["getEmployee"]),
     ...mapActions("updateEmployee", ["updateEmployee", "updateVisibleModalUpdate"]),
     ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),

      handleEventListenerOnInputs() {
        if (!this.isDataChanged && !this.isEmployeeSave && !this.isEmployeeUpdate) {
          this.updateDataInFormIsChanged(true);
        }
      },
      handleForm(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.addEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },
      removeEventListeners(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.removeEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },

     saveEmployeData: function() {
       this.data.language = localStorage.getItem("language");
       this.$refs.formS.resetValidation();
       this.rules = [];
       this.updateDataInFormIsChanged(false);
       if(this.layout === "edit") {
          this.updateEmployee({ creds: this.data });
       } else {
         this.data.hexColor = hexColorGenerator();
         this.storeEmployee({ creds: this.data });
       }
     },
     hideModal: function() {
       if(this.layout === "edit") {
          this.updateVisibleModalUpdate(false);
       } else {
         this.updateVisibleModal(false);
       }
     },
     save (date) {
       this.$refs.menu.save(date)
     },
   },
   watch: {
    'data.birthdate': {
       handler: function(newValue, oldValue) {
          if (newValue !== oldValue && oldValue !== undefined) {
            this.handleEventListenerOnInputs()
          }
        }
    },
     menu (val) {
       val && setTimeout(() => (this.activePicker = 'YEAR'))
     },
   },
   computed: {
     ...mapState("saveEmployee", {
       'dataSaveIsFetching': state => state.dataSaveIsFetching,
       'typeInfoEmployeeSave': state => state.typeInfoEmployeeSave,
       'headInfoEmployeeSave': state => state.headInfoEmployeeSave,
       'isEmployeeSave': state => state.isEmployeeSave,
       'textInfoEmployeeSave': state => state.textInfoEmployeeSave
     }),
     ...mapState("getEmployee", {
       "dataReceive": state => state.dataReceive
     }),
     ...mapState("updateEmployee", {
       "updateIsFetching": state => state.updateIsFetching,
       "textInfoEmployeeUpdate": state => state.textInfoEmployeeUpdate,
       "typeInfoEmployeeUpdate": state => state.typeInfoEmployeeUpdate,
       "headInfoEmployeeUpdate": state => state.headInfoEmployeeUpdate,
       "isEmployeeUpdate": state => state.isEmployeeUpdate
     }),
     ...mapState("preventDataLost", {
        isDataChanged: state => state.isDataChanged,
      })
   },
   beforeDestroy() {
    this.removeEventListeners('formS');
   }
 }
</script>